import { styled } from '@linaria/react'
import { FallbackImageSC } from 'atoms/FallbackImage'

export const PosterContainerBlurSC = styled.div<{
  backgroundImage: string | null
}>`
  height: 269px;
  width: 100%;
  background: ${({ backgroundImage }) =>
    backgroundImage
      ? `transparent url(${backgroundImage}) no-repeat center/cover`
      : 'none'};
  img {
    object-fit: contain;
    object-position: center;
    backdrop-filter: ${({ backgroundImage }) =>
      backgroundImage ? `blur(25px)` : 'none'};

    max-height: 100%;
    height: 100%;
    width: 100%;
  }
  ${FallbackImageSC} {
    height: 100%;
    width: 100%;
  }
`
